<div class="wrapper" id="sidebar">
  <div class="sidebar-wrapper" data-simplebar="true">
    <div class="sidebar-menu-wrapper">
      <div class="sidebar-header">
        <div>
          <a href="javascript:" (click)="navigateToDashboard()">
            <img src="../../assets/img/bharat-logo.png" class="logo-icon"
              [ngStyle]="{ 'height.px': isExpanded ? 65 : 40 }" alt="logo icon" />
          </a>
          <span (click)="closeLeftMenuforMobile()" class="d-md-none toggle-icon"
            style="position: absolute; top: 2% !important; right: 1% !important">
            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="red" class="bi bi-x"
              viewBox="0 0 16 16">
              <path
                d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
            </svg>
          </span>
        </div>
      </div>

      <div class="wrapper" style="margin-top: 9.6vh">
        <ul class="metismenu mt-4" id="menu">

          <!-- Dashboard -->
          <li style="padding: 0px" *ngIf="isShow == 'true'" [ngClass]="{
              parent: true,
              'mm-active': currentMenu === 'Dashboard',
              inactive: currentMenu != 'Dashboard'
            }">
            <a (click)="navigateToDashboard()" [attr.title]="isExpanded ? '' : 'Dashboard'">
              <span class="icon menu-icon">
                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="16" height="16" viewBox="0 0 17 17">
                  <path
                    d="M0.944444 9.44444H6.61111C7.13056 9.44444 7.55556 9.01944 7.55556 8.5V0.944444C7.55556 0.425 7.13056 0 6.61111 0H0.944444C0.425 0 0 0.425 0 0.944444V8.5C0 9.01944 0.425 9.44444 0.944444 9.44444ZM0.944444 17H6.61111C7.13056 17 7.55556 16.575 7.55556 16.0556V12.2778C7.55556 11.7583 7.13056 11.3333 6.61111 11.3333H0.944444C0.425 11.3333 0 11.7583 0 12.2778V16.0556C0 16.575 0.425 17 0.944444 17ZM10.3889 17H16.0556C16.575 17 17 16.575 17 16.0556V8.5C17 7.98056 16.575 7.55556 16.0556 7.55556H10.3889C9.86944 7.55556 9.44444 7.98056 9.44444 8.5V16.0556C9.44444 16.575 9.86944 17 10.3889 17ZM9.44444 0.944444V4.72222C9.44444 5.24167 9.86944 5.66667 10.3889 5.66667H16.0556C16.575 5.66667 17 5.24167 17 4.72222V0.944444C17 0.425 16.575 0 16.0556 0H10.3889C9.86944 0 9.44444 0.425 9.44444 0.944444Z" />
                </svg>
              </span>
              <span class="text menu-name">Dashboard</span>
            </a>
          </li>

          <!-- Menu Search -->
          <li style="padding: 0px" class="parent" *ngIf="roleId != 3">
            <a (click)="SearchMenuNav()" [attr.title]="isExpanded ? '' : 'Menu Search'">
              <span class="icon menu-icon"><i class="fas fa-search"></i></span>
              <span class="text menu-name">Menu Search</span>
            </a>
          </li>

          <!-- Dynamic menus from API -->
          <li style="padding: 0px" class="parent" *ngFor="let item of menus" [ngClass]="{
              parent: true,
              active: item.Name === currentMenu,
              'mm-active': isMenuOpen(item)
            }">
            <a [ngClass]="item.childs.length > 0 ? 'has-arrow' : ''"
              (click)="item.childs.length > 0 ? toggleMenu(item, $event) : navigate(item.path, item, $event)"
              [attr.title]="isExpanded ? '' : item.Name" [attr.target]="item.Name === 'LMS' ? '_blank' : '_self'">
              <span class="icon menu-icon" [attr.href]="'#' + getId(item.Name)">
                <i class="{{ item.CssClass }}"></i>
              </span>
              <span class="text menu-name">{{ item.Name }}</span>
            </a>
            <div class="wrapper" *ngIf="isMenuOpen(item)">
              <ul style="padding: 0px" class="style-2 shadow nav-active2 parent" *ngIf="item.childs.length"
                [attr.id]="getId(item.Name)">
                <li class="parent" *ngFor="let subMenu of item.childs" [ngClass]="{'mm-active': isMenuOpen(subMenu)}">
                  <a [ngClass]="subMenu.childs.length > 0 ? 'has-arrow' : ''"
                    (click)="subMenu.childs.length > 0 ? toggleMenu(subMenu, $event) : navigate(subMenu.path, subMenu, $event)">{{
                    subMenu.Name }}</a>
                  <div class="wrapper" *ngIf="isMenuOpen(subMenu)">
                    <ul class="style-3 shadow nav-active3" *ngIf="subMenu.childs.length">
                      <li class="parent" *ngFor="let menu of subMenu.childs" style="cursor: pointer"
                        [ngClass]="{'mm-active': isMenuOpen(menu)}">
                        <a [ngClass]="menu.childs.length > 0 ? 'has-arrow' : ''"
                          (click)="menu.childs.length > 0 ? toggleMenu(menu, $event) : navigate(menu.path, menu, $event)">{{
                          menu.Name }}</a>
                        <div class="wrapper" *ngIf="isMenuOpen(menu)">
                          <ul class="style-4 shadow nav-active4" *ngIf="menu.childs.length">
                            <li *ngFor="let fourthMenu of menu.childs" style="cursor: pointer"
                              [ngClass]="{'mm-active': isMenuOpen(fourthMenu)}">
                              <a [ngClass]="fourthMenu.childs.length > 0 ? 'has-arrow' : ''"
                                (click)="fourthMenu.childs.length > 0 ? toggleMenu(fourthMenu, $event) : navigate(fourthMenu.path, fourthMenu, $event)">{{
                                fourthMenu.Name }}</a>
                              <div class="wrapper" *ngIf="isMenuOpen(fourthMenu)">
                                <ul class="style-5 shadow nav-active5" *ngIf="fourthMenu.childs.length">
                                  <li *ngFor="let fifthMenu of fourthMenu.childs" style="cursor: pointer">
                                    <a [ngClass]="fifthMenu.childs.length > 0 ? 'has-arrow' : ''"
                                      (click)="navigate(fifthMenu.path, fifthMenu, $event)">{{ fifthMenu.Name }}</a>
                                  </li>
                                </ul>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>
            </div>
          </li>

          <!-- User Manual toggle -->
          <!-- <label class="mt-2" (click)="menusShow=!menusShow;">
            <i class="fas fa-book-open"></i>&nbsp;&nbsp;User Manual
          </label> -->

          <div *ngIf="menusShow">
            <ul class="main-menu">
              <li style="padding: 0px" class="parent" *ngFor="let item of menus"
                [ngClass]="{ parent: true, active: item.Name === currentMenu }">
                <a [ngClass]="item.childs.length > 0 ? 'has-arrow' : ''"
                  [routerLink]="['/HOME', 'um', item.Name, item.ID, 0, 0]" [attr.title]="isExpanded ? '' : item.Name"
                  [attr.target]="item.Name === 'LMS' ? '_blank' : '_self'">
                  <span class="icon menu-icon" [attr.href]="'#' + getId(item.Name)">
                    <i [class]="item.CssClass"></i>
                  </span>
                  <span class="text menu-name">{{ item.Name }}</span>
                </a>
                <div class="wrapper">
                  <ul style="padding: 0px" class="style-2 shadow nav-active2 parent" *ngIf="item.childs.length"
                    [attr.id]="getId(item.Name)">
                    <li class="parent" *ngFor="let subMenu of item.childs">
                      <a [ngClass]="subMenu.childs.length > 0 ? 'has-arrow' : ''"
                        [routerLink]="['/HOME', 'um', subMenu.Name, item.ID, subMenu.ID, 0]">
                        {{ subMenu.Name }}
                      </a>
                      <div class="wrapper">
                        <ul class="style-3 shadow nav-active3" *ngIf="subMenu.childs.length">
                          <li class="parent" *ngFor="let menu of subMenu.childs" style="cursor: pointer">
                            <a [ngClass]="menu.childs.length > 0 ? 'has-arrow' : ''"
                              [routerLink]="['/HOME', 'um', menu.Name, item.ID, subMenu.ID, menu.ID]">
                              {{ menu.Name }}
                            </a>
                            <div class="wrapper">
                              <ul class="style-4 shadow nav-active4" *ngIf="menu.childs.length">
                                <li *ngFor="let fourthMenu of menu.childs" style="cursor: pointer">
                                  <a [ngClass]="fourthMenu.childs.length > 0 ? 'has-arrow' : ''"
                                    (click)="navigate(fourthMenu.path, fourthMenu)">
                                    {{ fourthMenu.Name }}
                                  </a>
                                  <div class="wrapper">
                                    <ul class="style-5 shadow nav-active5" *ngIf="fourthMenu.childs.length">
                                      <li *ngFor="let fifthMenu of fourthMenu.childs" style="cursor: pointer">
                                        <a [ngClass]="fifthMenu.childs.length > 0 ? 'has-arrow' : ''"
                                          (click)="navigate(fifthMenu.path, fifthMenu)">
                                          {{ fifthMenu.Name }}
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>

          <!-- My Documents (students only) -->
          <li *ngIf="roleId == 3" style="padding: 0px" class="parent">
            <a (click)="mydocuments()" [attr.title]="isExpanded ? '' : 'My Documents'">
              <span class="icon menu-icon"><i class="fas fa-folder"></i></span>
              <span class="text menu-name">My Documents</span>
            </a>
          </li>

        </ul>
      </div>
    </div>
  </div>
</div>

<!-- Menu Search Modal -->
<div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
  aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="staticBackdropLabel">Menu Search</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="card" style="min-height: 25rem">
          <div class="row pt-5 pb-5">
            <div class="col-md-8 mx-auto">
              <label class="control-label">Menu Search</label>
              <div class="inputGroupContainer">
                <div class="input-group justify-content-center">
                  <ng-multiselect-dropdown style="width: 100%" [placeholder]="'Select Menu'" [(ngModel)]="selectedMenu"
                    [ngModelOptions]="{ standalone: true }" [settings]="dropdownSettings" [data]="allChilds"
                    (onSelect)="onItemSelect($event)" (onDeSelect)="onItemDeSelect($event)">
                  </ng-multiselect-dropdown>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" data-bs-dismiss="modal" (click)="closeSearch()">
          Close
        </button>
      </div>
    </div>
  </div>
</div>